
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { Image } from 'antd';
import { useEffect, useRef, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch } from "react-redux";
import { CommonApiData, initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, DropDownData, FileUploadChildMutil, FindTranslatedKey, convertToNumber, convertThreeDecimalsOnValue, convertTwoDecimalsOnValue, getDateAndTime, handleDateChange } from "../CommonComponents/CustomHooks";
import { AutoCompleteBoxNew, CheckboxSideLabel, DateBox, FormButton, InputBox, SelectInputBox } from "../CommonComponents/InputBox";
import { Table } from '../CommonComponents/Table';
const PickupRequest = ({ menuText }) => {
    //--Inital State--//
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [uploadCount, setUploadCount] = useState(0);
    const [showTermsModal, setShowTermsModal] = useState(false)
    const [isAutoFilled, setIsAutoFilled] = useState(false);
    const [isAutoFilledGst, setIsAutoFilledGst] = useState(false);
    const [isAutoFilledAdCode, setIsAutoFilledAdCode] = useState(false);
    const [currentDocType, setCurrentDocType] = useState('');
    const isFlagToFillConsginee = CommonApiData().IsCoCourier
    const [isChangeOrder, setIsChangeOrder] = useState(false)
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [openModal, setOpenModal] = useState(false)
    const [neededValueForModal, setNeededValueForModal] = useState('')
    const initalState = {
        agent: '',
        flight: '',
        pickupDate: getDateAndTime().date,
        serviceType: '0',
        shipmentType: '',
        client: '',
        consignor: '',
        consignorCompanyName: '',
        consignorAddress1: '',
        consignorAddress2: '',
        consignorPinCode: '',
        consignorCountry: '',
        consignorState: '',
        cityConsignor: '',
        contactPersonConsignor: '',
        phoneConsignor: '',
        emailConsignor: '',
        consignee: '',
        consigneeCompanyName: '',
        consigneeAddress1: '',
        consigneeAddress2: '',
        consigneePinCode: '',
        consigneeCountry: '',
        consigneeState: '',
        consigneeCity: '',
        contactPersonConsignee: '',
        phoneConsignee: '',
        emailConsignee: '',
        noOfPieces: '',
        weight: '',
        length: '',
        breadth: '',
        height: '',
        packageType: '',
        productDescription: '',
        hsnCode: '',
        declaredValue: '',
        currency: '',
        invoiceTerms: '',
        exportDeclaration: '',
        dgCompliance: '',
        iecNumber: '',
        gstNumber: '',
        adCode: '',
        purposeOfShipment: '',
        vendorName: '',
        localTrackingNumber: '',
        remarks: '',
        uploadFiles: [],
        termCondition: false,
        invoiceType: '',
        escalationEmail: CommonApiData()?.EscalationEmail ? CommonApiData()?.EscalationEmail : '',
        billToEmail: CommonApiData()?.BillToEmail ? CommonApiData()?.BillToEmail : '',
        billingService: '',
        freightBillTo: isFlagToFillConsginee ? '' : 'Client',
        dutyBillTo: isFlagToFillConsginee ? '' : 'Client',
        shipTo: isFlagToFillConsginee ? '' : 'Client',
        freight: '',
        tax: '',
        total: '',
        totalWeight: '',
        volumetricWeight: '',
        chargedWeight: '',
        fuel: '',
        clientRateID : '',
    }
    const [formData, setFormData] = useState(initalState)

    const getAgent = DropDownData('GetAgent')
    const getInvoiceType = DropDownData('GetInvoice')
    const getFlight = DropDownData('GetFlight')
    const getCurrency = DropDownData('GetCurrency')
    // const getServiceType = DropDownData('GetServiceType')
    const getPacketType = DropDownData('GetPacketType')
    const getInvoiceTerms = DropDownData('GetInvoiceTerms')
    const GetDocumentType = DropDownData('GetDocumentType')
    const getExportDeclaration = DropDownData('GetExportDeclaration')
    const getDGCompliance = DropDownData('GetDGCompliance')
    const getShipmentType = DropDownData('GetShipmentType')

    //--Handle Clear Function--//
    const handleClear = () => {
        if(CommonApiData()?.LoginUserType === 'Consignee' || !(isFlagToFillConsginee)){
            setFormData(prev => ({
                ...initalState, 
                consignee: prev.consignee || '',
                consigneeCompanyName: prev.consigneeCompanyName || '',
                consigneeAddress1: prev.consigneeAddress1 || '',
                consigneeAddress2: prev.consigneeAddress2 || '',
                consigneePinCode: prev.consigneePinCode || '',
                consigneeCountry: prev.consigneeCountry || '',
                consigneeState: prev.consigneeState || '',
                consigneeCity: prev.consigneeCity || '',
                contactPersonConsignee: prev.contactPersonConsignee || '',
                phoneConsignee: prev.phoneConsignee || '',
                emailConsignee: prev.emailConsignee || '',
            }))
        }else{
            setFormData(initalState)
        }
        setUploadCount(0)
        // inputrefs.current['txtInvoiceType'].focus();
        setIsAutoFilled(false)
        setIsAutoFilledGst(false)
        setIsAutoFilledAdCode(false)
        setCurrentDocType('')
    };

    //--handle Submit Function--//
    const handleSubmit = async () => {

        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Operation/InsertUpdatePickUpRequest', formData)
        await dispatch(setSubLoading(false))
        if( data.status === 'SUCCESS'){
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        }
        else if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs);
        }
    }



    const LoginUserType = CommonApiData().LoginUserType;
    const LoginUserCode = CommonApiData().LoginUserCode;


    useEffect(() => {
        if (!LoginUserType || !LoginUserCode) return;

        const value = LoginUserCode;

        if (LoginUserType === 'Consignor') {
            getconsignordataResquet(value);
        }
        else if (LoginUserType === 'Consignee') {
            getConsigneedataResquet(value);
        }

    }, [LoginUserType, LoginUserCode]);

    const getconsignordataResquet = async (value) => {

        let data = await ApiCall('/api/Operation/GetConsignorPickupDetails', { ConsignorConsigneeEmail: value });
        const res = data?.data || data;
        if (data.status === 'SUCCESS') {
            setFormData((prev) => ({
                ...prev,
                consignor: res.consignor,
                consignorCompanyName: res.consignorCompany,
                consignorAddress1: res.consignorAddress,
                consignorAddress2: res.consignorAddress1,
                consignorPinCode: res.consignorPinCode,
                consignorCountry: res.consignorCountry,
                consignorState: res.consignorState,
                cityConsignor: res.consignorCity,
                contactPersonConsignor: res.consignorContactPerson,
                phoneConsignor: res.consignorPhone,
                emailConsignor: res.consignorEmailID,
            }));
        }
        else {
            setFormData((prev) => ({
                ...prev,
                consignor: '',
                consignorCompanyName: '',
                consignorAddress1: '',
                consignorAddress2: '',
                consignorPinCode: '',
                consignorCountry: '',
                consignorState: '',
                cityConsignor: '',
                contactPersonConsignor: '',
                phoneConsignor: '',
                emailConsignor: value,
            }));
        }

    };
  

    const getConsigneedataResquet = async (value) => {

        let data = await ApiCall('/api/Operation/GetConsigneePickupDetails', { ConsignorConsigneeEmail: value });
        const res = data?.data || data;
        if (data.status === 'SUCCESS') {
            setFormData((prev) => ({
                ...prev,
                consignee: res.consignee,
                consigneeCompanyName: res.consigneeCompany,
                consigneeAddress1: res.consigneeAddress,
                consigneeAddress2: res.consigneeAddress1,
                consigneePinCode: res.consigneePinCode,
                consigneeCountry: res.consigneeCountry,
                consigneeState: res.consigneeState,
                consigneeCity: res.consigneeCity,
                contactPersonConsignee: res.consigneeContactPerson,
                phoneConsignee: res.consigneePhone,
                iecNumber: res.iecNumber ? res.iecNumber : '',
                gstNumber: res.gstNumber ? res.gstNumber : '',
                adCode: res.adCode ? res.adCode : '',
                emailConsignee: value
            }));
            setIsAutoFilled(!!res.iecNumber);
            setIsAutoFilledGst(!!res.gstNumber)
            setIsAutoFilledAdCode(!!res.adCode)
        }
        else {
            setFormData((prev) => ({
                ...prev,
                consignee: '',
                consigneeCompanyName: '',
                consigneeAddress1: '',
                consigneeAddress2: '',
                consigneePinCode: '',
                consigneeCountry: '',
                consigneeState: '',
                consigneeCity: '',
                contactPersonConsignee: '',
                phoneConsignee: '',
                iecNumber: '',
                gstNumber: '',
                adCode: '',
                emailConsignee: value
            }));
        }

    };

    const getConsigneedataByIsFlagToFillConsginee = async () => {
        let sendReqeset = {
            LoginClientCode: CommonApiData().LoginClientCode ? CommonApiData().LoginClientCode : ''
        }

        let data = await ApiCall('/api/Operation/GetConsigneeDetails', sendReqeset);
        const res = data?.data || data;
        if (data.status === 'SUCCESS') {
            setFormData((prev) => ({
                ...prev,
                consignee: res.consignee,
                consigneeCompanyName: res.consigneeCompany,
                consigneeAddress1: res.consigneeAddress,
                consigneeAddress2: res.consigneeAddress1,
                consigneePinCode: res.consigneePinCode,
                consigneeCountry: res.consigneeCountry,
                consigneeState: res.consigneeState,
                consigneeCity: res.consigneeCity,
                contactPersonConsignee: res.consigneeContactPerson,
                phoneConsignee: res.consigneePhone,
                iecNumber: res.iecNumber ? res.iecNumber : '',
                gstNumber: res.gstNumber ? res.gstNumber : '',
                adCode: res.adCode ? res.adCode : '',
                emailConsignee: res?.consigneeEmailID
            }));

        }
        else {
            setFormData((prev) => ({
                ...prev,
                consignee: '',
                consigneeCompanyName: '',
                consigneeAddress1: '',
                consigneeAddress2: '',
                consigneePinCode: '',
                consigneeCountry: '',
                consigneeState: '',
                consigneeCity: '',
                contactPersonConsignee: '',
                phoneConsignee: '',
                iecNumber: '',
                gstNumber: '',
                adCode: '',
                emailConsignee: ''
            }));
        }

    }



    const getFileNameAndExtension = (filename) => {
        const dotIndex = filename.lastIndexOf(".");
        return {
            name: filename.substring(0, dotIndex),
            extension: filename.substring(dotIndex + 1).toUpperCase(),
        };
    };

    const handleDeleteUpload = (index) => {
        setFormData((prev) => {
            const updatedFiles = prev.uploadFiles.filter((_, i) => i !== index);
            if (updatedFiles.length === 0) {
                setCurrentDocType('');
            }
            return {
                ...prev, uploadFiles: updatedFiles,
            };
        });
    };



    //--Initial state And function for modal--//
    const [showModalBox, setShowModalBox] = useState(false)
    const [fileExtension, setFileExtension] = useState('')
    const [base64FileData, setBase64FileData] = useState('')

    //--- for Modal Opening File start ----    //
    const base64ToBlob = (base64, mime) => {
        const byteChars = atob(base64);
        const byteArrays = [];
        for (let offset = 0; offset < byteChars.length; offset += 512) {
            const slice = byteChars.slice(offset, offset + 512);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        return new Blob(byteArrays, { type: mime });
    };

    const generatePdfUrl = (base64) => {
        const blob = base64ToBlob(base64, 'application/pdf');
        return URL.createObjectURL(blob);

    }; const generateImageUrl = (base64String) => {
        return `data:image/${fileExtension};base64,${base64String}`;
    };


    const handleModalDocShowClose = async () => {
        await setShowModalBox(false)
        await setFileExtension('')
        await setBase64FileData('')
    };

    const handleShowDoc = async (base64File, ext) => {
        await setFileExtension(ext)
        await setBase64FileData(base64File)
        await setShowModalBox(true);
    }
    const getStateAndCityConsignor = async (value) => {
        let data = await ApiCall('/api/Operation/GetPinCodeDetails', { 'Pincode': value })
        if (data.status === 'SUCCESS') {
            setFormData(prev => ({
                ...prev,
                consignorState: data?.state,
                cityConsignor: data?.city,
                consignorCountry: data?.country,
            }))

        } else {
            setFormData(prev => ({
                ...prev,
                consignorState: '',
                cityConsignor: '',
                consignorCountry: '',
            }))
        }
    };



    //--Grid Data Fetch Function--//
    const getModalDataGrid = async (CurrentPage, item) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {

            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            ClientRateID: item ? item : '',
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Operation/ViewClientRate', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED' || data.Status === 'ERROR') {
            setResult([])
        }
    }

    console.log(result, "jay shree ram ji")
    //--get Modal Grid Data--//

    const handleChange1 = (event, value) => {
        getModalDataGrid(value, neededValueForModal);
    };
    //--handle Sorting Function--//
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleViewRate = async () => {
        getModalDataGrid(1, neededValueForModal)
        setOpenModal(true)
    }





    const handleAmountDetailData = async (billingService, shipment, consignorPinCode, consignorCountry, consignorState, cityConsignor, consigneePinCode, consigneeCountry, consigneeState, consigneeCity, noOfPieces, weight, length, breadth, height, packageType, curreny, PickupDate, totalWeight, volumetricWeight, chargedWeight) => {

        const SendReqData = {
            "AwbNo": '',
            "PickupDate": PickupDate ? PickupDate : formData.pickupDate,
            "shipment": shipment ? shipment : '',
            "noOfPieces": noOfPieces ? noOfPieces : '',
            "BillingService": billingService ? billingService : formData.billingService,
            "WeightUnit": "",
            "CurrencyUnit": curreny ? curreny : formData.currency,
            "PacketType": packageType ? packageType : '',
            "ConsignorPinCode": consignorPinCode ? consignorPinCode : formData.consignorPinCode,
            "ConsignorCity": cityConsignor ? cityConsignor : formData.consignorCity,
            "ConsignorState": consignorState ? consignorState : formData.consignorState,
            "ConsignorCountry": consignorCountry ? consignorCountry : formData.consignorCountry,
            "ConsigneePinCode": consigneePinCode ? consigneePinCode : formData.consigneePinCode,
            "ConsigneeCity": consigneeCity ? consigneeCity : formData.consigneeCity,
            "ConsigneeState": consigneeState ? consigneeState : formData.consigneeState,
            "ConsigneeCountry": consigneeCountry ? consigneeCountry : formData.consigneeCountry,
            "Weight": weight ? weight : '',
            "Length": length ? length : '',
            "Breadth": breadth ? breadth : '',
            "Height": height ? height : '',
            "TotalWeight": totalWeight ? totalWeight : '',
            "VolumetricWeight": volumetricWeight ? volumetricWeight : '',
            "ChargedWeight": chargedWeight ? chargedWeight : ''
        }
        let data = await ApiCall('/api/Operation/GetFreightAmount', SendReqData)
        if (data.status === 'SUCCESS') {
            setFormData(prev => ({
                ...prev,
                clientRateID : data?.clientRateID,
                freight: data?.freight,
                fuel: data?.fuel,
                tax: data?.tax,
                total: data?.totalAmount,

            }))
            setNeededValueForModal(data.clientRateID)
        } else {
            setFormData(prev => ({
                ...prev,
                clientRateID : '',
                freight: '',
                fuel: '',
                tax: '',
                total: '',
            }))
        }
    }

    const handleTotalWeightAmount = (weight, length, breadth, height, noOfPieces) => {
        // const totalWeight = (parseFloat(weight) || 0) * (parseFloat(noOfPieces) || 0);
        const totalWeight = parseFloat(weight) || 0
        const volumetricWeight = ((parseFloat(length) || 0) * (parseFloat(breadth) || 0) * (parseFloat(height) || 0)) / 5000;
        return { totalWeight, volumetricWeight };
    }

    useEffect(() => {
        const { totalWeight, volumetricWeight } = handleTotalWeightAmount(formData.weight, formData.length, formData.breadth, formData.height, formData.noOfPieces);
        const weightValue = parseFloat(formData.weight) || 0;
        setFormData(prev => ({
            ...prev,
            volumetricWeight: volumetricWeight.toFixed(3),
            chargedWeight: Math.ceil(
                volumetricWeight > weightValue ? volumetricWeight : weightValue
            ).toFixed(3),
            totalWeight: totalWeight.toFixed(3)
        }))
    }, [formData.weight, formData.length, formData.breadth, formData.height, formData.noOfPieces])


    const getStateAndCityConsignee = async (value) => {
        let data = await ApiCall('/api/Operation/GetPinCodeDetails', { 'Pincode': value })
        if (data.status === 'SUCCESS') {
            setFormData(prev => ({
                ...prev,
                consigneeState: data?.state,
                consigneeCity: data?.city,
                consigneeCountry: data?.country,
            }))
        } else {
            setFormData(prev => ({
                ...prev,
                consigneeState: '',
                consigneeCity: '',
                consigneeCountry: '',
            }))
        }
    };

    useEffect(() => {
        if (getPacketType?.data?.dataList?.length > 0 && !formData.packageType) {
            setFormData(prev => ({
                ...prev,
                packageType: getPacketType.data.dataList[0].code
            }));
        }
    }, [getPacketType]);


    useEffect(() => {
        if (formData.termCondition) {
            setShowTermsModal(true)
        }
        else {
            setShowTermsModal(false)
        }
    }, [formData.termCondition])

    useEffect(() => {
        // inputrefs.current['txtInvoiceType'].focus();
        document.title = 'Pickup Request'
    }, [])


    useEffect(() => {

        handleAmountDetailData(formData.billingService, formData.shipmentType, formData.consignorPinCode, formData.consignorCountry, formData.consignorState, formData.cityConsignor, formData.consigneePinCode, formData.consigneeCountry, formData.consigneeState,
            formData.consigneeCity, formData.noOfPieces, formData.weight, formData.length, formData.breadth, formData.height, formData.packageType, formData.currency, formData.pickupDate, formData.totalWeight, formData.volumetricWeight, formData.chargedWeight);

    }, [formData.billingService, formData.shipmentType, formData.consignorPinCode, formData.consignorCountry, formData.consignorState, formData.cityConsignor, formData.consigneePinCode,
    formData.consigneeCountry, formData.consigneeState, formData.consigneeCity, formData.packageType, formData.currency, formData.pickupDate, formData.totalWeight, formData.volumetricWeight, formData.chargedWeight]);

    useEffect(() => {
        if (!isFlagToFillConsginee) {
            getConsigneedataByIsFlagToFillConsginee()
        }

    }, [isFlagToFillConsginee])

    useEffect(() => {
        if (getInvoiceType?.data?.dataList?.length === 1) {
            setFormData((prev) => ({
                ...prev,
                invoiceType: getInvoiceType.data.dataList[0].code
            }));
        }
    }, [getInvoiceType]);


    return (
        <>
            <div className='main-card PickUp_Entry card border-0'>
                <div className='card-header mb-1'>
                    <div className='d-flex align-items-center gap-2' style={{ marginTop: '-5px' }}>
                        <span className="fs-6 fw-bold headingspan " style={{ marginRight: "4px" }}> {menuText ? menuText : FindTranslatedKey('PickUp Request')}</span>
                    </div>
                </div>

                <div className='card-body px-3'>
                    <div className="rounded py-1 px-2 mb-2 " style={{ boxShadow: 'rgba(101, 155, 242, 0.5) 0px 0px 5px', borderTop: "2px solid #f18282" }} >
                        <div className='row'>
                            <SelectInputBox
                                label='Invoice Type'
                                inputrefs={inputrefs}
                                id='txtInvoiceType'
                                required={true}
                                value={formData.invoiceType}
                                disabled={getInvoiceType?.data?.dataList?.length === 1}
                                onChange={(e) =>
                                    setFormData({ ...formData, invoiceType: e.target.value })
                                }
                            >
                                {getInvoiceType?.data?.dataList?.length !== 1 && (
                                    <option value=''>--Please Select--</option>
                                )}

                                {getInvoiceType?.data?.dataList?.map((item, index) => (
                                    <option key={item.name + index} value={item.code}>
                                        {FindTranslatedKey(item.name)}
                                    </option>
                                ))}
                            </SelectInputBox>

                            <SelectInputBox
                                label='Agent'
                                inputrefs={inputrefs}
                                id='txtAgent'
                                required={true}
                                value={formData.agent}
                                onChange={(e) => setFormData({ ...formData, agent: e.target.value })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtFlight']?.focus();
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                {getAgent?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.code}>
                                        {FindTranslatedKey(item.name)}
                                    </option>
                                )}
                            </SelectInputBox>
                            <SelectInputBox
                                label='Flight / Transit Flight'
                                inputrefs={inputrefs}
                                id='txtFlight'
                                required={true}
                                value={formData.flight}
                                onChange={(e) => setFormData({ ...formData, flight: e.target.value })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtPickupDate']?.focus();
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                {getFlight?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.code}>
                                        {FindTranslatedKey(item.name)}
                                    </option>
                                )}
                            </SelectInputBox>
                            <DateBox
                                inputrefs={inputrefs}
                                label="Pickup Date"
                                placeholder="Pickup Date"
                                id='txtPickupDate'
                                preventOpenOnFocus={true}
                                required
                                selected={formData.pickupDate === '' ? '' : new Date(formData.pickupDate)}
                                onChange={(e) => {
                                    const updatedDate = e
                                    handleDateChange(updatedDate, setFormData, formData, 'pickupDate')

                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtServiceType']?.focus();
                                    }
                                }}
                            />
                            {/* <SelectInputBox
                                label='Service Type'
                                inputrefs={inputrefs}
                                id='txtServiceType'
                                required={true}
                                value={formData.serviceType}
                                onChange={(e) => setFormData({ ...formData, serviceType: e.target.value })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtShipmentType']?.focus();
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                {getServiceType?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.code}>
                                        {FindTranslatedKey(item.name)}
                                    </option>
                                )}
                            </SelectInputBox> */}



                            <SelectInputBox
                                label='Shipment Type'
                                inputrefs={inputrefs}
                                id='txtShipmentType'
                                required={true}
                                value={formData.shipmentType}
                                onChange={(e) => {
                                    const value = e.target.value
                                    setFormData({ ...formData, shipmentType: value })


                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtConsignor']?.focus();
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                {getShipmentType?.data?.dataList?.map((item, index) =>
                                    <option key={item.name + index} value={item.code}>{FindTranslatedKey(item.name)}</option>
                                )}
                            </SelectInputBox>
                            {(LoginUserType === 'Consignee' || LoginUserType === 'Consignor') &&
                                <AutoCompleteBoxNew
                                    label='Client'
                                    placeholder='Client'
                                    value={formData.client || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, client: newInputValue, });
                                        }
                                    }}
                                    maxLength='50'
                                    required={true}
                                    inputrefs={inputrefs}
                                    id="txtClient"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtEmailConsignor']?.focus();
                                        }
                                    }}
                                    autocompleteType='GetClient'

                                />
                            }

                            <InputBox
                                label="Bill To Email"
                                placeholder="Bill To Email"
                                inputrefs={inputrefs}
                                id='txtBillToEmail'
                                value={formData.billToEmail || ''}
                                maxLength='100'
                                onChange={(e) => setFormData({ ...formData, billToEmail: e.target.value })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtEscalationEmail']?.focus();
                                    }
                                }}
                            />


                            <InputBox
                                label="Escalation Email"
                                placeholder="Escalation Email"
                                inputrefs={inputrefs}
                                id='txtEscalationEmail'
                                value={formData.escalationEmail || ''}
                                maxLength='100'
                                onChange={(e) => setFormData({ ...formData, escalationEmail: e.target.value })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtBillingService']?.focus();
                                    }
                                }}
                            />

                            <AutoCompleteBoxNew
                                label='Billing Service'
                                placeholder='Billing Service'
                                value={formData.billingService || ''}
                                onChange={(event, newInputValue) => {
                                    newInputValue = newInputValue || '';
                                    if (event.type !== 'keydown') {
                                        setFormData({ ...formData, billingService: newInputValue, });


                                    }
                                }}
                                maxLength='50'

                                inputrefs={inputrefs}
                                id="txtBillingService"
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtEmailConsignor']?.focus();
                                    }
                                }}

                                autocompleteType='GetBillingService'

                            />
                            <SelectInputBox
                                label='Ship To'
                                inputrefs={inputrefs}
                                id='txtShipTo'
                                value={formData.shipTo}
                                disabled={!(isFlagToFillConsginee)}
                                onChange={(e) => setFormData({ ...formData, shipTo: e.target.value })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtDutyBillTo']?.focus();
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                <option value='Client'>Client</option>
                                <option value='Consignor'>Consignor</option>
                                <option value='Consignee'>Consignee</option>

                            </SelectInputBox>

                            <SelectInputBox
                                label='Duty Bill To'
                                inputrefs={inputrefs}
                                id='txtDutyBillTo'
                                value={formData.dutyBillTo}
                                 disabled={!(isFlagToFillConsginee)}
                                onChange={(e) => setFormData({ ...formData, dutyBillTo: e.target.value })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtFreightBillTo']?.focus();
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                <option value='Client'>Client</option>
                                <option value='Consignor'>Consignor</option>
                                <option value='Consignee'>Consignee</option>

                            </SelectInputBox>

                            <SelectInputBox
                                label='Freight Bill To'
                                inputrefs={inputrefs}
                                id='txtFreightBillTo'
                                value={formData.freightBillTo}
                                 disabled={!(isFlagToFillConsginee)}
                                onChange={(e) => setFormData({ ...formData, freightBillTo: e.target.value })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtEmailConsignor']?.focus();
                                    }
                                }}
                            >
                                <option value=''>--Please Select--</option>
                                <option value='Client'>Client</option>
                                <option value='Consignor'>Consignor</option>
                                <option value='Consignee'>Consignee</option>

                            </SelectInputBox>
                        </div>
                    </div>
                    <div className='main-items-2 gap-1 d-flex my-2' >
                        <div className='items-2 rounded' style={{ borderTop: '2px solid var(--first_theme)' }}>
                            <div className='row  my-1 ' style={{ marginTop: '2px' }}>
                                <div className="col-lg-4 col-md-5 col-sm-12 pb-2 pe-2 pb-2">
                                    <h6 className='mb-0' style={{ fontSize: '12px' }}> {FindTranslatedKey('Consignor / Shipper')}</h6>
                                </div>

                            </div>
                            <div className='row'>
                                {/*<InputBox*/}
                                {/*    label="Email"*/}
                                {/*    placeholder="Email"*/}
                                {/*    inputrefs={inputrefs}*/}
                                {/*    divclassname='col-sm-4 mb-1'*/}
                                {/*    required={true}*/}
                                {/*    id='txtEmailConsignor'*/}
                                {/*    value={formData.emailConsignor || ''}*/}
                                {/*    maxLength='100'*/}

                                {/*    onChange={(e) => {*/}
                                {/*        setFormData({ ...formData, emailConsignor: (e.target.value) })*/}
                                {/*        setIsChangeValue(true)*/}
                                {/*    }}*/}
                                {/*    onBlur={() => {*/}
                                {/*        if (isChangeValue) {*/}
                                {/*            setIsChangeValue(false)*/}
                                {/*            getconsignordataResquet(formData.emailConsignor)*/}
                                {/*        }*/}
                                {/*    }}*/}
                                {/*    onKeyDown={(e) => {*/}
                                {/*        if (e.key === 'Enter') {*/}
                                {/*            inputrefs.current['txtConsignor']?.focus();*/}
                                {/*        }*/}
                                {/*    }}*/}
                                {/*/>*/}


                                <AutoCompleteBoxNew
                                    label='Email'
                                    placeholder='Email'
                                    divclassname='col-sm-4 mb-1'
                                    value={formData.emailConsignor || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, emailConsignor: newInputValue, });
                                            getconsignordataResquet(newInputValue);
                                        }
                                    }}
                                    maxLength='50'
                                    required={true}
                                    inputrefs={inputrefs}
                                    id="txtEmailConsignor"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsignor']?.focus();
                                        }
                                    }}
                                    autocompleteType='GetClientConsignorEmail'

                                />




                                <AutoCompleteBoxNew
                                    label='Consignor'
                                    placeholder='Consignor'
                                    divclassname='col-sm-4 mb-1'
                                    value={formData.consignor || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, consignor: newInputValue, });

                                        }
                                    }}
                                    maxLength='50'
                                    required={true}
                                    inputrefs={inputrefs}
                                    id="txtConsignor"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsignorCompanyName']?.focus();
                                        }
                                    }}
                                    contextKey={formData.emailConsignor}
                                    autocompleteType='GetClientConsignor'

                                />

                                <InputBox
                                    label="Company Name"
                                    placeholder="Company Name"
                                    divclassname='col-sm-4 mb-1'
                                    inputrefs={inputrefs}
                                    id='txtConsignorCompanyName'
                                    value={formData.consignorCompanyName || ''}
                                    maxLength='100'
                                    onChange={(e) => setFormData({ ...formData, consignorCompanyName: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsignorAddress1']?.focus();
                                        }
                                    }}
                                />
                                <InputBox
                                    label=" Address Line 1"
                                    required={true}
                                    placeholder="Address Line 1"
                                    inputrefs={inputrefs}
                                    divclassname='col-sm-4 mb-1'
                                    id='txtConsignorAddress1'
                                    value={formData.consignorAddress1 || ''}
                                    maxLength='150'
                                    onChange={(e) => setFormData({ ...formData, consignorAddress1: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsignorAddress2']?.focus();
                                        }
                                    }}
                                />


                                <InputBox
                                    label="Address Line 2"
                                    placeholder="Address Line 2"
                                    divclassname='col-sm-4 mb-1'
                                    inputrefs={inputrefs}
                                    id='txtConsignorAddress2'
                                    value={formData.consignorAddress2 || ''}
                                    maxLength='150'
                                    onChange={(e) => setFormData({ ...formData, consignorAddress2: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtCityConsignor']?.focus();
                                        }
                                    }}
                                />

                                <AutoCompleteBoxNew
                                    label='PinCode'
                                    placeholder='PinCode'
                                    divclassname='col-sm-4 mb-1'
                                    value={formData.consignorPinCode || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, consignorPinCode: newInputValue });
                                            getStateAndCityConsignor(newInputValue ? newInputValue : '')



                                        }
                                    }
                                    }
                                    inputrefs={inputrefs}
                                    id="txtConsignorPinCode"
                                    autocompleteType='GetPincode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsignorCountry']?.focus();
                                        }
                                    }}
                                />

                                <AutoCompleteBoxNew
                                    label='Country'
                                    placeholder='Country'
                                    required={true}
                                    divclassname='col-sm-4 mb-1'
                                    value={formData.consignorCountry || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, consignorCountry: newInputValue, consignorState: '' });

                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    id="txtConsignorCountry"
                                    autocompleteType='GetCountry'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsignorState']?.focus();
                                        }
                                    }}
                                />
                                <AutoCompleteBoxNew
                                    label='State'
                                    placeholder='State'
                                    divclassname='col-sm-4 mb-1'
                                    value={formData.consignorState || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, consignorState: newInputValue, cityConsignor: '' });

                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    id="txtConsignorState"
                                    autocompleteType='GetState_CountryWise'
                                    contextKey={formData.consignorCountry}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtCityConsignor']?.focus();
                                        }
                                    }}
                                />

                                <AutoCompleteBoxNew
                                    label='City'
                                    placeholder='City'
                                    divclassname='col-sm-4 mb-1'
                                    value={formData.cityConsignor || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, cityConsignor: newInputValue });


                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    id="txtCityConsignor"
                                    autocompleteType='GetCity_StateWise'
                                    contextKey={formData.consignorState}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtContactPersonConsignor']?.focus();
                                        }
                                    }}
                                />

                                <InputBox
                                    label="Contact Person"
                                    placeholder="Contact Person"
                                    inputrefs={inputrefs}
                                    divclassname='col-sm-4 mb-1'
                                    id='txtContactPersonConsignor'
                                    value={formData.contactPersonConsignor || ''}
                                    maxLength='100'
                                    onChange={(e) => setFormData({ ...formData, contactPersonConsignor: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtPhoneConsignor']?.focus();
                                        }
                                    }}
                                />


                                <InputBox
                                    label="Phone Number"
                                    placeholder="Phone Number"
                                    divclassname='col-sm-4 mb-1'
                                    required={true}
                                    inputrefs={inputrefs}
                                    id='txtPhoneConsignor'
                                    value={formData.phoneConsignor || ''}
                                    maxLength='15'
                                    onChange={(e) => setFormData({ ...formData, phoneConsignor: convertToNumber(e.target.value) })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsignee']?.focus();
                                        }
                                    }}
                                />




                            </div>
                        </div>
                        <div className='items-2 rounded' style={{ borderTop: '2px solid var(--first_theme)' }}>
                            <div className='row my-1' style={{ marginTop: '2px' }}>
                                <div className="col-lg-4 col-md-5 col-sm-12 pb-2 pe-2 pb-2">
                                    <h6 className='mb-0' style={{ fontSize: '12px' }}>{FindTranslatedKey('Consignee/Receiver')} </h6>
                                </div>

                            </div>
                            <div className='row'>




                                <AutoCompleteBoxNew
                                    label='Email'
                                    placeholder='Email'
                                    divclassname='col-sm-4 mb-1'
                                    value={formData.emailConsignee || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, emailConsignee: newInputValue });

                                            getConsigneedataResquet(newInputValue)
                                        }
                                    }}
                                    maxLength='50'
                                    required={true}
                                    inputrefs={inputrefs}
                                    disabled={LoginUserType === 'Consignee' || !(isFlagToFillConsginee)}
                                    id="txtEmailConsignee"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsigneeCompanyName']?.focus();
                                        }
                                    }}
                                    autocompleteType='GetClientConsigneeEmail'
                                />



                                <AutoCompleteBoxNew
                                    label='Consignee'
                                    placeholder='Consignee'
                                    divclassname='col-sm-4 mb-1'
                                    value={formData.consignee || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, consignee: newInputValue });

                                        }
                                    }}
                                    maxLength='50'
                                    required={true}
                                    inputrefs={inputrefs}
                                    disabled={LoginUserType === 'Consignee' || !(isFlagToFillConsginee)}
                                    id="txtConsignee"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsigneeCompanyName']?.focus();
                                        }
                                    }}
                                    contextKey={formData.emailConsignee}
                                    autocompleteType='GetClientConsignee'
                                />

                                <InputBox
                                    label="Company Name"
                                    placeholder="Company Name"
                                    divclassname='col-sm-4 mb-1'
                                    inputrefs={inputrefs}
                                    disabled={!(isFlagToFillConsginee) }
                                    id='txtConsigneeCompanyName'
                                    value={formData.consigneeCompanyName || ''}
                                    maxLength='100'
                                    onChange={(e) => setFormData({ ...formData, consigneeCompanyName: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsigneeAddress1']?.focus();
                                        }
                                    }}
                                />

                                <InputBox
                                    label="Address Line 1"
                                    placeholder="Address Line 1"
                                    required={true}
                                    divclassname='col-sm-4 mb-1'
                                    inputrefs={inputrefs}
                                    disabled={!(isFlagToFillConsginee)}
                                    id='txtConsigneeAddress1'
                                    value={formData.consigneeAddress1 || ''}
                                    maxLength='150'
                                    onChange={(e) => setFormData({ ...formData, consigneeAddress1: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsigneeAddress2']?.focus();
                                        }
                                    }}
                                />

                                <InputBox
                                    label="Address Line 2"
                                    placeholder="Address Line 2"
                                    divclassname='col-sm-4 mb-1'
                                    inputrefs={inputrefs}
                                    disabled={!(isFlagToFillConsginee)}
                                    id='txtConsigneeAddress2'
                                    value={formData.consigneeAddress2 || ''}
                                    maxLength='150'
                                    onChange={(e) => setFormData({ ...formData, consigneeAddress2: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsigneePinCode']?.focus();
                                        }
                                    }}
                                />

                                <AutoCompleteBoxNew
                                    label='PinCode'
                                    placeholder='PinCode'
                                    divclassname='col-sm-4 mb-1'
                                    value={formData.consigneePinCode || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, consigneePinCode: newInputValue });
                                            getStateAndCityConsignee(newInputValue ? newInputValue : '')


                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    disabled={!(isFlagToFillConsginee)}
                                    id="txtConsigneePinCode"
                                    autocompleteType='GetPincode'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsigneeCountry']?.focus();
                                        }
                                    }}
                                />

                                <AutoCompleteBoxNew
                                    label='Country'
                                    placeholder='Country'
                                    required={true}
                                    divclassname='col-sm-4 mb-1'
                                    disabled={!(isFlagToFillConsginee)}
                                    value={formData.consigneeCountry || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, consigneeCountry: newInputValue });

                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    id="txtConsigneeCountry"
                                    autocompleteType='GetCountry'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsigneeState']?.focus();
                                        }
                                    }}
                                />

                                <AutoCompleteBoxNew
                                    label='State'
                                    placeholder='State'
                                    divclassname='col-sm-4 mb-1'
                                    value={formData.consigneeState || ''}
                                    disabled={!(isFlagToFillConsginee)}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, consigneeState: newInputValue });

                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    id="txtConsigneeState"
                                    autocompleteType='GetState_CountryWise'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtConsigneeCity']?.focus();
                                        }
                                    }}
                                    contextKey={formData.consigneeCountry}
                                />

                                <AutoCompleteBoxNew
                                    label='City'
                                    placeholder='City'
                                    divclassname='col-sm-4 mb-1'
                                    disabled={!(isFlagToFillConsginee)}
                                    value={formData.consigneeCity || ''}
                                    onChange={(event, newInputValue) => {
                                        newInputValue = newInputValue || '';
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, consigneeCity: newInputValue });

                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    id="txtConsigneeCity"
                                    autocompleteType='GetCity_StateWise'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtContactPersonConsignee']?.focus();
                                        }
                                    }}
                                    contextKey={formData.consigneeState}
                                />

                                <InputBox
                                    label="Contact Person"
                                    placeholder="Contact Person"
                                    disabled={!(isFlagToFillConsginee)}
                                    divclassname='col-sm-4 mb-1'
                                    inputrefs={inputrefs}
                                    id='txtContactPersonConsignee'
                                    value={formData.contactPersonConsignee || ''}
                                    maxLength='100'
                                    onChange={(e) => setFormData({ ...formData, contactPersonConsignee: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtPhoneConsignee']?.focus();
                                        }
                                    }}
                                />

                                <InputBox
                                    label="Phone Number"
                                    required={true}
                                    disabled={LoginUserType === 'Consignee' || !(isFlagToFillConsginee)}
                                    placeholder="Phone Number"
                                    divclassname='col-sm-4 mb-1'
                                    inputrefs={inputrefs}
                                    id='txtPhoneConsignee'
                                    value={formData.phoneConsignee || ''}
                                    maxLength='15'
                                    onChange={(e) => setFormData({ ...formData, phoneConsignee: convertToNumber(e.target.value) })}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtNoOfPieces']?.focus();
                                        }
                                    }}
                                />


                            </div>
                        </div>
                    </div>






                    <div className='mb-2 main_card border-0'>
                        <div className='package-card other_details' >
                            <div className='grn-card-item' style={{ borderColor: '#5C8DEB' }}>
                                <div className='w-100 d-flex'>
                                    <h6 className='mb-0 mt-1'>{FindTranslatedKey('Shipment Details')}</h6>
                                </div>
                                <div className='row other_cn_details mt-1'>
                                    <InputBox
                                        label="Number of Pieces"
                                        id='txtNoOfPieces'
                                        inputrefs={inputrefs}
                                        required={true}
                                        maxLength='5'


                                        value={formData.noOfPieces || ''}

                                        onChange={(e) => {
                                            setFormData({ ...formData, noOfPieces: convertToNumber(e.target.value) })
                                            setIsChangeOrder(true)
                                        }}
                                        onBlur={() => {
                                            if (isChangeOrder) {

                                                handleAmountDetailData(formData.billingService, formData.shipmentType, formData.consignorPinCode, formData.consignorCountry, formData.consignorState, formData.cityConsignor,
                                                    formData.consigneePinCode, formData.consigneeCountry, formData.consigneeState, formData.consigneeCity, formData.noOfPieces, formData.weight, formData.length, formData.breadth,
                                                    formData.height, formData.packageType, formData.currency, formData.PickupDate)
                                                setIsChangeOrder(false)
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtWeight']?.focus();
                                            }
                                        }}
                                    />

                                    <InputBox
                                        label="Weight (kg)"
                                        id='txtWeight'
                                        required={true}
                                        inputrefs={inputrefs}
                                        maxLength='10'
                                        value={formData.weight || ''}
                                        onChange={(e) => {
                                            setFormData({ ...formData, weight: convertThreeDecimalsOnValue(e.target.value) })
                                            setIsChangeOrder(true)
                                        }}
                                        onBlur={() => {
                                            if (isChangeOrder) {

                                                handleAmountDetailData(formData.billingService, formData.shipmentType, formData.consignorPinCode, formData.consignorCountry, formData.consignorState, formData.cityConsignor,
                                                    formData.consigneePinCode, formData.consigneeCountry, formData.consigneeState, formData.consigneeCity, formData.noOfPieces, formData.weight, formData.length, formData.breadth,
                                                    formData.height, formData.packageType, formData.currency, formData.pickupDate)
                                                setIsChangeOrder(false)
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtLength']?.focus();
                                            }
                                        }}
                                    />

                                    <InputBox
                                        label="Length"
                                        id='txtLength'
                                        required={true}
                                        inputrefs={inputrefs}
                                        maxLength='10'
                                        value={formData.length || ''}
                                        onChange={(e) => {
                                            setFormData({ ...formData, length: convertThreeDecimalsOnValue(e.target.value) })
                                            setIsChangeOrder(true)
                                        }}
                                        onBlur={() => {
                                            if (isChangeOrder) {

                                                handleAmountDetailData(formData.billingService, formData.shipmentType, formData.consignorPinCode, formData.consignorCountry, formData.consignorState, formData.cityConsignor,
                                                    formData.consigneePinCode, formData.consigneeCountry, formData.consigneeState, formData.consigneeCity, formData.noOfPieces, formData.weight, formData.length, formData.breadth,
                                                    formData.height, formData.packageType, formData.currency, formData.pickupDate)
                                                setIsChangeOrder(false)
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtBreadth']?.focus();
                                            }
                                        }}
                                    />

                                    <InputBox
                                        label="Breadth"
                                        id='txtBreadth'
                                        required={true}
                                        inputrefs={inputrefs}
                                        maxLength='10'
                                        value={formData.breadth || ''}
                                        onChange={(e) => {
                                            setFormData({ ...formData, breadth: convertThreeDecimalsOnValue(e.target.value) })
                                            setIsChangeOrder(true)
                                        }}
                                        onBlur={() => {
                                            if (isChangeOrder) {

                                                handleAmountDetailData(formData.billingService, formData.shipmentType, formData.consignorPinCode, formData.consignorCountry, formData.consignorState, formData.cityConsignor,
                                                    formData.consigneePinCode, formData.consigneeCountry, formData.consigneeState, formData.consigneeCity, formData.noOfPieces, formData.weight, formData.length, formData.breadth,
                                                    formData.height, formData.packageType, formData.currency, formData.pickupDate)
                                                setIsChangeOrder(false)
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtHeight']?.focus();
                                            }
                                        }}
                                    />

                                    <InputBox
                                        label="Height"
                                        id='txtHeight'
                                        required={true}
                                        inputrefs={inputrefs}
                                        maxLength='10'
                                        value={formData.height || ''}
                                        onChange={(e) => {
                                            setFormData({ ...formData, height: convertThreeDecimalsOnValue(e.target.value) })
                                            setIsChangeOrder(true)
                                        }}
                                        onBlur={() => {
                                            if (isChangeOrder) {

                                                handleAmountDetailData(formData.billingService, formData.shipmentType, formData.consignorPinCode, formData.consignorCountry, formData.consignorState, formData.cityConsignor,
                                                    formData.consigneePinCode, formData.consigneeCountry, formData.consigneeState, formData.consigneeCity, formData.noOfPieces, formData.weight, formData.length, formData.breadth,
                                                    formData.height, formData.packageType, formData.currency, formData.pickupDate)
                                                setIsChangeOrder(false)
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtPackageType']?.focus();
                                            }
                                        }}
                                    />




                                    <InputBox
                                        label="Total Weight"
                                        disabled
                                        placeholder="0.00"
                                        inputrefs={inputrefs}
                                        id='txtTotalWeight'
                                        value={formData.totalWeight || ''}
                                        maxLength='50'
                                        onChange={(e) => setFormData({ ...formData, totalWeight: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['']?.focus();
                                            }
                                        }}
                                    />
                                    <InputBox
                                        label="Volumetric Weight"
                                        disabled
                                        placeholder="0.00"
                                        inputrefs={inputrefs}
                                        id='txtVolumetricWeight'
                                        value={formData.volumetricWeight || ''}
                                        maxLength='50'
                                        onChange={(e) => setFormData({ ...formData, volumetricWeight: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['']?.focus();
                                            }
                                        }}
                                    />

                                    <InputBox
                                        label="Charged Weight"
                                        disabled
                                        placeholder="0.00"
                                        inputrefs={inputrefs}
                                        id='txtChargedWeight'
                                        value={formData.chargedWeight || ''}
                                        maxLength='50'
                                        onChange={(e) => setFormData({ ...formData, chargedWeight: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['']?.focus();
                                            }
                                        }}
                                    />





                                    <SelectInputBox
                                        label='Packet Type'
                                        id='txtPackageType'
                                        required={true}
                                        inputrefs={inputrefs}
                                        value={formData.packageType || ''}
                                        onChange={(e) => {
                                            const val = e.target.value
                                            setFormData({ ...formData, packageType: val })


                                        }}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtProductDescription']?.focus();
                                            }
                                        }}
                                    >

                                        {getPacketType?.data?.dataList?.map((item, index) =>
                                            <option key={item.name + index} value={item.code}>
                                                {FindTranslatedKey(item.name)}
                                            </option>
                                        )}
                                    </SelectInputBox>

                                    <InputBox
                                        label="Product Description"
                                        id='txtProductDescription'
                                        inputrefs={inputrefs}
                                        maxLength='250'
                                        value={formData.productDescription || ''}
                                        onChange={(e) => setFormData({ ...formData, productDescription: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtHSNCode']?.focus();
                                            }
                                        }}
                                    />

                                    <InputBox
                                        label="HSN Code"
                                        id='txtHSNCode'
                                        inputrefs={inputrefs}
                                        value={formData.hsnCode || ''}
                                        onChange={(e) => setFormData({ ...formData, hsnCode: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtDeclaredValue']?.focus();
                                            }
                                        }}
                                    />

                                    <InputBox
                                        label="Declared Value"
                                        id='txtDeclaredValue'
                                        inputrefs={inputrefs}
                                        value={formData.declaredValue || ''}
                                        onChange={(e) => setFormData({ ...formData, declaredValue: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtCurrency']?.focus();
                                            }
                                        }}
                                    />

                                    <SelectInputBox
                                        label='Currency'
                                        id='txtCurrency'
                                        required={true}
                                        inputrefs={inputrefs}
                                        value={formData.currency || ''}
                                        onChange={(e) => {
                                            const value = e.target.value
                                            setFormData({ ...formData, currency: value })

                                        }}
                                    >
                                        <option value=''>--Please Select--</option>
                                        {getCurrency?.data?.dataList?.map((item, index) =>
                                            <option key={item.name + index} value={item.code}>
                                                {FindTranslatedKey(item.name)}
                                            </option>
                                        )}
                                    </SelectInputBox>

                                </div>

                            </div>
                        </div>
                    </div>
                    <div className='mb-2 main_card border-0'>
                        <div className='package-card other_details' >
                            <div className='grn-card-item' style={{ borderColor: '#5C8DEB' }}>
                                <div className='w-100 d-flex'>
                                    <h6 className='mb-0 mt-1'>{FindTranslatedKey('Amount Details')}</h6>
                                </div>
                                <div className='row other_cn_details mt-1'>
                                    <InputBox
                                        label="Total Freight"
                                        disabled
                                        placeholder="Total Freight"
                                        inputrefs={inputrefs}
                                        id='txtfreight'
                                        value={formData.freight || ''}
                                        maxLength='15'
                                        onChange={(e) => setFormData({ ...formData, freight: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtTax']?.focus();
                                            }
                                        }}
                                    />
                                    <InputBox
                                        label="Fuel"
                                        disabled
                                        placeholder="Fuel"
                                        inputrefs={inputrefs}
                                        id='txtFuel'
                                        value={formData.fuel || ''}
                                        maxLength='15'
                                        onChange={(e) => setFormData({ ...formData, fuel: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtTotal']?.focus();
                                            }
                                        }}
                                    />
                                    {/* <InputBox
                                        label="Tax"
                                        disabled
                                        placeholder="Tax"
                                        inputrefs={inputrefs}
                                        id='txtTax'
                                        value={formData.tax || ''}
                                        maxLength='15'
                                        onChange={(e) => setFormData({ ...formData, tax: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtTotal']?.focus();
                                            }
                                        }}
                                    /> */}

                                    <InputBox
                                        label="Total"
                                        disabled
                                        placeholder="Total"
                                        inputrefs={inputrefs}
                                        id='txtTotal'
                                        value={formData.total || ''}
                                        maxLength='15'
                                        onChange={(e) => setFormData({ ...formData, total: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtNoOfPieces']?.focus();
                                            }
                                        }}
                                    />
                                    <div className='col-md-3 d-flex align-items-end'>
                                        <button
                                            type="button"
                                            onClick={handleViewRate}
                                            className="btn btn-rounded btn-success"
                                        >
                                            <span className="text-white me-2">
                                                <i className="fa-solid fa-pen-to-square text-white color-success"></i>
                                            </span>
                                            {FindTranslatedKey('View Rate')}
                                        </button>
                                    </div>



                                </div>

                            </div>
                        </div>
                    </div>


                    <div className='mb-2 main_card border-0'>
                        <div className='other_details other_details' >
                            <div className=' grn-card-item' style={{ borderColor: '#5C8DEB' }}>
                                <div className='w-100 d-flex'>
                                    <h6 className='mb-0 mt-1'>{FindTranslatedKey('Commercial & Compliance')}</h6>
                                </div>
                                <div className='row other_cn_details mt-1'>
                                    <SelectInputBox
                                        label='Invoice Terms'
                                        id='txtInvoiceTerms'
                                        inputrefs={inputrefs}
                                        value={formData.invoiceTerms || ''}
                                        onChange={(e) => setFormData({ ...formData, invoiceTerms: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtExportDeclaration']?.focus();
                                            }
                                        }}
                                    >
                                        <option value=''>--Please Select--</option>
                                        {getInvoiceTerms?.data?.dataList?.map((item, index) =>
                                            <option key={item.name + index} value={item.code}>{FindTranslatedKey(item.name)}</option>
                                        )}
                                    </SelectInputBox>


                                    <SelectInputBox
                                        label='Export Declaration'
                                        id='txtExportDeclaration'
                                        inputrefs={inputrefs}
                                        value={formData.exportDeclaration || ''}
                                        onChange={(e) => setFormData({ ...formData, exportDeclaration: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtDGCompliance']?.focus();
                                            }
                                        }}
                                    >
                                        <option value=''>--Please Select--</option>
                                        {getExportDeclaration?.data?.dataList?.map((item, index) =>
                                            <option key={item.name + index} value={item.code}>{FindTranslatedKey(item.name)}</option>
                                        )}
                                    </SelectInputBox>


                                    <SelectInputBox
                                        label='DG Compliance'
                                        id='txtDGCompliance'
                                        inputrefs={inputrefs}
                                        value={formData.dgCompliance || ''}
                                        onChange={(e) => setFormData({ ...formData, dgCompliance: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtIECNumber']?.focus();
                                            }
                                        }}
                                    >
                                        <option value=''>--Please Select--</option>
                                        {getDGCompliance?.data?.dataList?.map((item, index) =>
                                            <option key={item.name + index} value={item.code}>{FindTranslatedKey(item.name)}</option>
                                        )}
                                    </SelectInputBox>


                                    <InputBox
                                        label="IEC Number"
                                        id='txtIECNumber'
                                        inputrefs={inputrefs}
                                        value={formData.iecNumber || ''}
                                        disabled={isAutoFilled}
                                        maxLength='20'
                                        onChange={(e) => setFormData({ ...formData, iecNumber: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtGSTNumber']?.focus();
                                            }
                                        }}
                                    />

                                    <InputBox
                                        label="GST Number"
                                        id='txtGSTNumber'
                                        inputrefs={inputrefs}
                                        disabled={isAutoFilledGst}
                                        value={formData.gstNumber || ''}
                                        maxLength='20'
                                        onChange={(e) => setFormData({ ...formData, gstNumber: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtADCode']?.focus();
                                            }
                                        }}
                                    />


                                    <InputBox
                                        label="AD Code"
                                        id='txtADCode'
                                        inputrefs={inputrefs}
                                        disabled={isAutoFilledAdCode}
                                        value={formData.adCode || ''}
                                        maxLength='20'
                                        onChange={(e) => setFormData({ ...formData, adCode: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtPurposeOfShipment']?.focus();
                                            }
                                        }}
                                    />


                                    <InputBox
                                        label="Purpose of Shipment"
                                        id='txtPurposeOfShipment'
                                        inputrefs={inputrefs}
                                        value={formData.purposeOfShipment || ''}
                                        maxLength='200'
                                        onChange={(e) => setFormData({ ...formData, purposeOfShipment: e.target.value })}
                                    />

                                </div>

                            </div>
                        </div>
                    </div>


                    <div className='mb-2 main_card border-0'>
                        <div className='package-card other_details' >
                            <div className='grn-card-item' style={{ borderColor: '#5C8DEB' }}>
                                <div className='w-100 d-flex'>
                                    <h6 className='mb-0 mt-1'>{FindTranslatedKey('Tracking / Vendor Info')}</h6>
                                </div>
                                <div className='row other_cn_details mt-1'>

                                    <AutoCompleteBoxNew
                                        label='Vendor '
                                        placeholder='Vendor '

                                        value={formData.vendorName || ''}
                                        onChange={(event, newInputValue) => {
                                            newInputValue = newInputValue || '';
                                            if (event.type !== 'keydown') {
                                                setFormData({ ...formData, vendorName: newInputValue });
                                            }
                                        }}
                                        inputrefs={inputrefs}
                                        id="txtVendorName"
                                        autocompleteType='GetVendor'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtLocalTrackingNumber']?.focus();
                                            }
                                        }}
                                    />

                                    <InputBox
                                        label="Local Tracking Number"
                                        placeholder="Local Tracking Number"
                                        inputrefs={inputrefs}
                                        id='txtLocalTrackingNumber'
                                        value={formData.localTrackingNumber || ''}
                                        maxLength='50'
                                        onChange={(e) => setFormData({ ...formData, localTrackingNumber: e.target.value })}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtRemarks']?.focus();
                                            }
                                        }}
                                    />


                                    <InputBox
                                        label="Remarks / Special Instructions"
                                        placeholder="Remarks"
                                        inputrefs={inputrefs}
                                        id='txtRemarks'
                                        value={formData.remarks || ''}
                                        maxLength='300'
                                        onChange={(e) => setFormData({ ...formData, remarks: e.target.value })}
                                    />

                                </div>

                            </div>
                        </div>
                    </div>


                    <div className='mb-2 main_card border-0'>
                        <div className='package-card other_details' >
                            <div className='grn-card-item' style={{ borderColor: '#5C8DEB' }}>
                                <div className='w-100 d-flex'>
                                    <h6 className='mb-0 mt-1'>{FindTranslatedKey('Document Upload')}</h6>
                                </div>
                                <div className='row other_cn_details mt-1'>
                                    <SelectInputBox
                                        label='Document Type'
                                        required
                                        inputrefs={inputrefs}
                                        id='txtDocumentType'
                                        value={currentDocType}
                                        onChange={(e) => {
                                            setCurrentDocType(e.target.value);
                                        }}

                                    >
                                        <option value=''>--Please Select--</option>
                                        {GetDocumentType?.data?.dataList?.map((item, index) =>
                                            <option key={item.name + index} value={item.code}>
                                                {FindTranslatedKey(item.name)}
                                            </option>
                                        )}
                                    </SelectInputBox>

                                    <div
                                        className={`col-md-3  cntrl-width mb-1`}
                                        ref={ref => (inputrefs.current['txtEmpPhoto'] = ref)}  >
                                        <label className="form-label"> Upload File <span style={{ color: 'red', fontWeight: 500, marginLeft: '3px', fontSize: '10px' }}>( File Size ≤ 2MB.)</span>  </label>
                                        <FileUploader
                                            multiple={true}
                                            classes='upload-section file-uploader'
                                            name="file"
                                            types={["JPG", "PNG", "PDF", "JPEG"]}
                                            handleChange={(files) => {
                                                if (!currentDocType) {
                                                    NotificationSound('ERROR', 'Please select Document Type ');
                                                    return;
                                                }
                                                const maxSize = 2 * 1024 * 1024;
                                                const selectedFiles = Array.from(files);
                                                setUploadCount(prev => prev + selectedFiles.length);

                                                selectedFiles.forEach((file) => {
                                                    if (file.size > maxSize) {
                                                        // alert(`${file.name} size must be ≤ 2MB!`);
                                                        NotificationSound('ERROR', `${file.name} size must be ≤ 2MB!`, null, null, null);
                                                        setUploadCount(0)
                                                        return;
                                                    }

                                                    const { name, extension } = getFileNameAndExtension(file.name);
                                                    const reader = new FileReader();

                                                    reader.onload = () => {
                                                        const base64 = reader.result.split(",")[1];
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            uploadFiles: [
                                                                ...prev.uploadFiles,
                                                                {
                                                                    uploadFile: base64,
                                                                    uploadExt: extension,
                                                                    uploadFileName: name,
                                                                    documentType: currentDocType,
                                                                },
                                                            ],
                                                        }));
                                                    };

                                                    reader.readAsDataURL(file);
                                                });
                                            }}
                                            children={<FileUploadChildMutil label='' message={uploadCount > 0 ? `${uploadCount} files` : ''} types={["JPG", "PNG", "PDF", "JPEG"]} />}

                                        />

                                    </div>


                                    {formData?.uploadFiles && formData?.uploadFiles?.length > 0 && <>
                                        <div className="panel panel-primary mt-2">
                                            <div className="panel-heading py-1 px-2" style={{ fontSize: '13px', fontWeight: '600', backgroundColor: '#D7D4CF', }}>{`Total Records: ${formData?.uploadFiles?.length}`}</div>
                                            <div className="panel-body">
                                                <div className="table-responsive" style={{ maxHeight: "267px", overflowY: "auto", position: 'relative' }}>
                                                    <table className="table table-bordered table-striped">
                                                        <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 2 }}>


                                                            <tr className="light-bg">
                                                                <th >Sr.</th>
                                                                <th>Document Type</th>
                                                                <th>File Name</th>
                                                                <th>Extension</th>
                                                                <th>Preview</th>
                                                                <th>Action</th>
                                                            </tr>

                                                        </thead>
                                                        <tbody style={{ fontSize: "12px" }}>
                                                            {formData.uploadFiles.map((file, index) => (
                                                                <tr key={index}>
                                                                    <td style={{ padding: '0 8px' }}>{index + 1}</td>
                                                                    <td>{file.documentType}</td>
                                                                    <td>{file.uploadFileName}</td>
                                                                    <td>{file.uploadExt}</td>
                                                                    <td>
                                                                        {["JPG", "PNG", "JPEG"].includes(file.uploadExt) ? (
                                                                            <Image
                                                                                width={40}
                                                                                src={`data:image/${file.uploadExt.toLowerCase()};base64,${file.uploadFile}`}
                                                                            />


                                                                        ) : file.uploadExt === "PDF" ? (
                                                                            <i className="fa-solid fa-file-pdf fa-lg text-danger" onClick={() => handleShowDoc(file.uploadFile, file.uploadExt)}></i>
                                                                        ) : (
                                                                            <i className="fa-solid fa-file fa-lg"></i>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        <button
                                                                            className="btn btn-danger btn-sm"
                                                                            onClick={() => handleDeleteUpload(index)}
                                                                        >
                                                                            <i className="fa-solid fa-trash"></i>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>





                                    </>}






                                </div>

                            </div>
                        </div>
                    </div>



                    <div className='mb-2 main_card border-0'>
                        <div className='package-card other_details' >
                            <div className='grn-card-item' style={{ borderColor: '#5C8DEB' }}>
                                <div className='w-100 d-flex'>
                                    <h6 className='mb-0 mt-1'>{FindTranslatedKey('Terms & Declaration')}</h6>
                                </div>
                                <div className='row other_cn_details mt-1'>
                                    <CheckboxSideLabel
                                        label='Term And Condition'
                                        id='txtTermCondition'
                                        checked={formData.termCondition}
                                        onChange={(e) => {
                                            let checkValue = e.target.checked;
                                            setFormData({ ...formData, termCondition: checkValue, })

                                        }}
                                    />

                                </div>



                            </div>
                        </div>
                    </div>



                    <div className='row pb-1 mt-2'>
                        <FormButton
                            id='btnSave'
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            Export={false}
                            handleClear={handleClear} />
                    </div>
                </div>
            </div>

            <Dialog
                open={showModalBox}
                onClose={handleModalDocShowClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={false}
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "100%",
                            maxWidth: "800px",
                        }

                    },
                    "& .css-hz1bth-MuiDialog-container": {
                        alignItems: 'start'
                    },
                    "& .MuiPaper-root": {
                        width: '95vw',
                        maxWidth: '1000px',
                        borderRadius: '8px',
                    },
                }}>

                <DialogTitle id="alert-dialog-title" className="py-1 px-2 border-bottom d-flex justify-content-between align-items-center" >
                    <div style={{ fontWeight: 500 }}>Document View </div>
                    <div className="d-flex align-items-center gap-3">
                        <i className="fa-solid fa-xmark" onClick={handleModalDocShowClose} title="Close" style={{ cursor: 'pointer', fontSize: '20px', backgroundColor: 'red', padding: '2px', borderRadius: '5px' }} />
                    </div>
                </DialogTitle>

                <DialogContent className='main-card px-0 m-2 py-1' style={{ boxShadow: 'none', }} >

                    {fileExtension.toUpperCase() === 'PDF' ? (
                        <iframe
                            title="PDF Preview"
                            src={generatePdfUrl(base64FileData)}
                            style={{ width: '100%', height: '700px', border: 'none' }}
                        />
                    ) : (
                        <img
                            src={generateImageUrl(base64FileData)}
                            alt="File Preview"
                            style={{ width: '100%', height: 'auto', objectFit: 'contain', }}

                        />
                    )}
                </DialogContent>
            </Dialog>

            <Dialog
                open={showTermsModal}
                onClose={() => {
                    setShowTermsModal(false);
                    setFormData({ ...formData, termCondition: false });
                }}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle style={{ fontWeight: 600 }}>
                    Terms & Conditions
                </DialogTitle>

                <DialogContent>

                    <div className="bg-light border rounded-3 p-3 mb-3" style={{ maxHeight: 220, overflowY: 'auto' }}>
                        <div className="d-flex gap-2 mb-3">
                            <span className="mt-2 rounded-circle bg-primary flex-shrink-0" style={{ width: 7, height: 7 }}></span>
                            <p className="small text-secondary mb-0 lh-lg">
                                By submitting this pickup request, you confirm that all shipment details are correct
                                and comply with applicable regulations. The company shall not be responsible for delays
                                caused by incorrect information, customs clearance issues, or unforeseen circumstances.
                            </p>
                        </div>
                        <div className="d-flex gap-2 mb-3">
                            <span className="mt-2 rounded-circle bg-primary flex-shrink-0" style={{ width: 7, height: 7 }}></span>
                            <p className="small text-secondary mb-0 lh-lg">
                                You agree to follow all export compliance rules, safety standards, and documentation
                                requirements. Any violation may result in shipment cancellation or penalties.
                            </p>
                        </div>
                        <div className="d-flex gap-2">
                            <span className="mt-2 rounded-circle bg-primary flex-shrink-0" style={{ width: 7, height: 7 }}></span>
                            <p className="small text-secondary mb-0 lh-lg">
                                Please read carefully before proceeding. Clicking "I Agree" indicates acceptance of
                                these terms.
                            </p>
                        </div>
                    </div>


                    <div className="d-flex align-items-start gap-2 bg-warning bg-opacity-10 border border-warning rounded-3 p-3 mb-4">
                        <i className="fa-solid fa-triangle-exclamation text-warning mt-1"></i>
                        <p className="small text-warning-emphasis mb-0">
                            Clicking <strong>"I Agree"</strong> is legally binding. Ensure all details are accurate before accepting.
                        </p>
                    </div>


                    <div className="d-flex gap-2">
                        <button
                            type="button"
                            id='btnCancel'
                            ref={ref => (inputrefs.current['btnCancel'] = ref)}
                            onClick={() => {
                                setShowTermsModal(false);
                                setFormData({ ...formData, termCondition: false });
                            }}
                            className="btn btn-outline-secondary rounded-3 px-4 py-2 fw-semibold d-flex align-items-center gap-2"
                        >
                            <i className="fa-solid fa-xmark"></i> Cancel
                        </button>
                        <button
                            type="button"
                            id='btnAccept'
                            ref={ref => (inputrefs.current['btnAccept'] = ref)}
                            onClick={() => {
                                setFormData({ ...formData, termCondition: true });
                                setShowTermsModal(false);
                            }}
                            className="btn btn-primary rounded-3 px-4 py-2 fw-semibold d-flex align-items-center gap-2 flex-grow-1 justify-content-center"
                        >
                            <i className="fa-solid fa-circle-check"></i> I Agree & Continue
                        </button>
                    </div>
                </DialogContent>
            </Dialog>


            <Dialog
                open={openModal}
                onClose={() => {
                    setOpenModal(false)
                    setResult([])
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    "& .MuiDialog-container": {
                        alignItems: "flex-start",
                    },
                    "& .MuiPaper-root": {
                        marginTop: "100px",
                        width: "100%",
                        maxWidth: "900px",
                    }
                }} >



                <DialogTitle
                    id="alert-dialog-title"
                    className="border-bottom"
                    sx={{ py: 1, px: 2, display: "flex", alignItems: "center", justifyContent: "space-between", }} >
                    {/*<span style={{ fontSize: "15px", fontWeight: 600 }}>*/}
                    {/*    {neededValueForModal} Data*/}
                    {/*</span>*/}
                    <div className="d-flex align-items-center gap-2">
                        {/*<button type="button" className="btn btn-sm btn-warning d-flex align-items-center"*/}
                        {/*    >*/}
                        {/*    <i className="fa fa-download me-2 text-white"></i>*/}
                        {/*    Export*/}
                        {/*</button>*/}

                        <button
                            type="button"
                            className="btn btn-sm btn-light"
                            title="Close"
                            onClick={() => {
                                setOpenModal(false)
                                setResult([])
                            }}
                            style={{ borderRadius: "50%", width: "32px", height: "32px", }} >
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                    </div>
                </DialogTitle>

                <DialogContent className='main-card px-0 mx-0 my-0 py-1' style={{ boxShadow: 'none' }}>
                    <div className='row px-0 mx-0 pb-1 border-bottom'>
                        <Table
                            PageName={'Dashboard'}
                            loading={loading}
                            handleFilter={() => {
                                getModalDataGrid(1, neededValueForModal)
                                setFilterData({
                                    ...filterData,
                                })
                            }}
                            Filter={false}
                            onlyFilterPage={true}
                            filterData={filterData}
                            tableData={result}
                            setFilterData={setFilterData}
                            currentPageNo={currentPageNo}
                            handleChange1={handleChange1}
                            handleSorting={handleSorting}
                            sortConfig={sortConfig}
                        />
                    </div>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default PickupRequest;